import { z } from 'zod';

/**
 * Signage-mode configuration. When the `signageMode` feature flag is
 * entitled AND `signage.rotationIntervalSeconds` is set, the launcher
 * cycles through `profiles[]` in array order at that interval —
 * useful for unattended displays (lobby tablet rotating Morning /
 * Lunch / Happy hour menus, drive-thru order-screen, etc.).
 *
 * Rotation is independent of `schedules` — when both are set, signage
 * rotation wins (it's the more specific "this device is an unattended
 * display" intent). Schedules are still honored on devices without
 * signageMode active.
 *
 * Lower bound 10s lets QA-style tight cycles work; upper 3600s caps
 * at an hour (longer than that and you'd just use a schedule).
 */
export const Signage = z.object({
  rotationIntervalSeconds: z.number().int().min(10).max(3600).optional(),
});
export type Signage = z.infer<typeof Signage>;
